import { Tooltip } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC } from "react";
import TooltipContentExpense, {
  type TooltipContentExpenseProps,
} from "./TooltipContentExpense";

export const TooltipExpense: FC<
  React.PropsWithChildren<TooltipContentExpenseProps>
> = observer(function TooltipExpense({ children, ...props }) {
  return (
    <Tooltip maxW="380px" label={<TooltipContentExpense {...props} />}>
      <div>{children}</div>
    </Tooltip>
  );
});
